import React, { useState } from "react";
import ThemedCalendar from "./ThemedCalender";

const CustomDatePicker = ({
  value,
  onChange,
  defaultYear = new Date().getFullYear(),
  defaultMonth = new Date().getMonth(),
  placeholder = "Select Date",
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [selectedYear, setSelectedYear] = useState(defaultYear);

  // Handle date selection
  const handleDateSelect = (type, value) => {
    if (type === "month") {
      setSelectedMonth(value);
    } else if (type === "year") {
      setSelectedYear(value);
    } else if (type === "day") {
      const formattedDate = `${selectedYear}-${String(
        selectedMonth + 1
      ).padStart(2, "0")}-${String(value).padStart(2, "0")}`;
      onChange(formattedDate);
      setShowCalendar(false);
    }
  };

  return (
    <div className="relative">
      {/* Date Input Field */}
      <input
        type="text"
        value={value || ""}
        onFocus={() => setShowCalendar(true)}
        readOnly
        placeholder={placeholder}
        className="w-full h-10 px-4 border border-gray-300 rounded-md cursor-pointer"
      />

      {/* Render Calendar if Open */}
      {showCalendar && (
        <ThemedCalendar
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          onSelectDate={handleDateSelect}
          onClose={() => setShowCalendar(false)}
        />
      )}
    </div>
  );
};

export default CustomDatePicker;
